<template>
    <div class="container-fluid mt-5 ">
      <div class="row mx-0 mx-lg-4">
        <!-- Colonne pour le texte encapsulé dans FilmCard -->
        <div class="col-md-6 film-texte ">
          <FilmCard v-if="film" :film="film" />
          <p v-else>Film non trouvé.</p>
        </div>
        <!-- Colonne pour les photos -->
        <div class="col-md-6">
          <div v-if="film.photos && film.photos.length" class="d-flex flex-wrap">
            <div v-for="(photo, index) in film.photos" :key="index" class="mb-4">
              <img :src="require(`@/assets/${film.photoDirectory}/${photo}`)" class="img-fluid" alt="Photo du film" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import FilmCard from '@/components/FilmCard.vue';
  
  export default {
    components: {
      FilmCard,
    },
    props: ['id'],
    data() {
      return {
        films: [
          {
            id: 1,
            title: 'Mamma',
            year: '2020',
            duration: '26 min',
            synopsis: `Alors qu'elle menait un combat de tous les jours contre son cancer, je tombe par hasard sur des cassettes vidéo de ma mère : ses voyages, son mariage, ma naissance. Son présent, occulté par la maladie, dissonait avec les archives où je la voyais rayonnante, insouciante, aimante. Sentant que sa vie me filait entre les doigts, avant qu'elle ne s'éteigne, j'ai voulu une dernière fois la faire parler et la photographier en argentique.`,
            crew: {
              'Réalisation, image, son et montage': 'Pablo Cirès',
            },
            festivals: [
              { name: 'Sélectionné dans le cadre d’Images en Bibliothèque', link: 'https://imagesenbibliotheques.fr/docotheque/mamma-0' },
            ],
            availability: {
              text: 'Disponible en DVD ici',
              link: 'https://bibliotheques-specialisees.paris.fr/ark:/73873/pf0002422525',
            },
            photoDirectory: 'Mamma',
            photos: ['0002_5.jpg', 'F1000013.jpg', 'F1000018.jpg'],
          },
          {
            id: 2,
            title: 'Arcobaleno',
            year: 'En cours',
            production: 'Les films du Bilboquet & Blink Blink Prod',
            duration: '',
            synopsis: `Depuis 50 ans, ma grand-mère Iolanda est la reine de l’Arcobaleno, un dancing au sud de Rome devenu avec le temps un lieu incontournable de la région. Mais tout comme ses clients, le dancing vieillit et la fin semble proche. Seule Elisa, sa petite-fille, rêve de reprendre les rênes de l’Arcobaleno pour le transformer en un parc de jeux pour enfants.`,
            crew: {
              'Réalisation, image et son': 'Pablo Cirès',
              'Son': 'Sébastien Pont',
              'Montage': 'Léa Chatauret',
            },
            festivals: [
              { name: 'Les Pitchs d’Addoc - 2021', link: '' },
              { name: 'Rencontres d’Août – États généraux du documentaire – 2022', link: '' },
              { name: 'Résidence CECI du Moulin d’Andé – 2022', link: '' },
              { name: 'FIPADOC – Pitchs Premiers films européens 2024', link: '' },
              { name: 'Cinéastes en résidence - Périphérie 2024', link: '' },
            ],
            // availability: {
            //   text: 'Musique du film disponible ici',
            //   link: 'https://cires.bandcamp.com/',
            // },
            photoDirectory: 'Arcobaleno',
            photos: [ 'Iolanda_10.jpg',  'Arcobaleno_1.jpg','Erminio_5.jpg', ],
          },
        ],
        film: null,
      };
    },
    created() {
        this.loadFilm();
},
watch: {
    // Surveille les changements de la prop `id`
    id() {
      this.loadFilm();
    },
  },

methods: {
    loadFilm() {
      const filmId = parseInt(this.id || this.$route.params.id);
      this.film = this.films.find(f => f.id === filmId);
      if (!this.film) {
        console.error('Film non trouvé');
      }
    }
  },

  mounted() {
    // Réinitialise le scroll en haut de la page quand ce composant est monté
    window.scrollTo(0, 0);
  }
  };
  </script>
  
  <style scoped>
.img-fluid {
  max-width: 100%;
  height: auto;
}

.film-texte{
    text-align: left;
    /* padding-left: 20px; */
}
  </style>